import { render, staticRenderFns } from "./area-facility-modal.vue?vue&type=template&id=6d4ed059"
import script from "./area-facility-modal.vue?vue&type=script&lang=js"
export * from "./area-facility-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports